import { Box } from '@material-ui/core'
import React, { useContext } from 'react'
import AppContext from '../../../app/context'
import AppImage from '../../../components/AppImage'
import buildStyles from './styles'

const LeftSide = () => {
  const { state } = useContext(AppContext)

  if (!state.locationDesignConfig) return null
  const styles = buildStyles({
    baseColors: state.locationDesignConfig.baseColors,
  })

  return (
    <Box className={styles.leftSide}>
      <AppImage
        alt="background-image"
        imageId={state.locationConfig?.backgroundId}
        disabledPadding
        shouldContain
      />
    </Box>
  )
}

export default LeftSide
